module.exports = __webpack_public_path__ + "static/media/awbLogo.edda9012.png";